export const sortObject = <T extends Record<string, any>>(obj: T): T => {
  const sorted = new Map(Object.entries(obj).sort());
  const sortedObject: T = {} as T;

  for (const [key, val] of sorted) {
    sortedObject[key as keyof T] = val;
  }

  return sortedObject;
};
